<template>
  <router-link
    :to="{
      name: 'talent-pool-job-detail',
      params: { jobId: props.job.unfilled_shift_group_id, locationId },
    }"
    :class="['job-container', { current: props.job.unfilled_shift_group_id === currentJobId }]"
  >
    <div class="job">
      <div class="info">
        <div class="meta">
          <span class="role">{{ props.job.external_role_name }}</span>
          <span v-if="props.job.closed_at" class="closed">Closed</span>
          <div v-else>
            <span>{{ props.job.applicant_count || 0 }} applicant{{ props.job.applicant_count !== 1 ? 's' : '' }}</span>
            <span> > </span>
            <span>{{ props.job.shortlisted_count || 0 }} shortlisted</span>
            <span> > </span>
            <span>{{ props.job.assigned_count || 0 }} assigned</span>
          </div>
        </div>
        <div class="price">
          <span v-if="props.job.properties.pay_amount" class="salary">{{ props.job.properties.pay_amount }}</span>
        </div>
      </div>
    </div>
    <div v-if="!props.last" class="line" />
  </router-link>
</template>

<script setup>
import { useRoute } from 'vue-router/composables';

const route = useRoute();
const locationId = route.params.locationId;
const currentJobId = route.params.jobId;

const props = defineProps(['job', 'last']);
</script>

<style scoped lang="scss">
.line {
  height: 1px;
  background: var(--palette-color-default-lighten-90);
  margin: 0 1rem;
}

.job {
  padding: 1rem 12px;
  background: var(--palette-color-base-white);
  display: flex;
  align-items: center;
  color: var(--palette-color-default);
  transition: 0.2s;
}

.job-container.current .job {
  background-color: var(--palette-color-core-1-lighten-90);
  border-left: 5px solid var(--palette-color-brand-primary);
}

.job:hover {
  background-color: var(--palette-color-core-1-lighten-90);
}

.info {
  display: flex;
  flex-grow: 1;
  font-weight: 300;
  font-size: 14px;
  gap: 12px;
}

.info .meta {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.shortlisted {
  font-weight: 400;
  color: var(--palette-color-default-lighten-20);
}

.info .price {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.info .role {
  font-size: 16px;
  font-weight: 600;
}

.info .applicants {
  font-size: 16px;
  font-weight: 600;
}

.salary {
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.01em;
  text-align: end;
}

.closed {
  font-weight: 500;
  color: var(--palette-color-brand-primary);
}
</style>
